import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "slash-forward-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { id: "20x20/Filled/Slash-Forward", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M8.929 15.372a1 1 0 01-1.857-.743l4-10a1 1 0 011.857.743l-4 10z", id: "Line", fill: "currentColor", fillRule: "nonzero" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
